<template>
  <section class="news">
    <div class="news__content">
      <div v-if="cities.length > 0 && net">
        <Back :to="`/team`" />

        <div class="block">
          <div class="block__header">Список салонов</div>
          <Salon
            v-for="city in cities"
            :id="city.id"
            :key="city.id"
            :name="`${net.name} в ${city.name}`"
            :workers="city.workers"
            :year="city.year"
            :offices="city.offices"
            :link="city.link"
          />
        </div>
      </div>
      <div v-else class="news__loader">
        <Loader />
      </div>
    </div>

    <div class="news__side">
      <Note />
    </div>
  </section>
</template>

<script setup>
import Salon from '@/components/team/Salon'
import Loader from '@/components/Loader'
import Note from '@/components/Note'
import Back from '@/components/Back'
import authorize from '@/mixins/authorize'
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

const store = useStore()
const router = useRouter()
const net = ref('')
const cities = ref([])

const getCities = async () => {
  const data = await fetch(`https://barberkuzma.ru:1414/barbershops/?nameEng=${router.currentRoute.value.params.net}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  })
  const response = await data.json()
  net.value = response[0]

  if (net.value.id == 1) net.value.cities = net.value.cities.filter(city => city.id != 1)
  if (net.value.id == 2) net.value.cities = net.value.cities.filter(city => city.id != 1 && city.id != 4)

  for (const city of net.value.cities) {
    processCities(city)
  }
}

const processCities = async city => {
  const dataWorkers = await fetch(
    `https://barberkuzma.ru:1414/staff?profileBarbershop=${net.value.id}&profileCity=${city.id}`,
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  )
  const responseWorkers = await dataWorkers.json()

  const dataOffices = await fetch(
    `https://barberkuzma.ru:1414/adresses/?barbershop.id=${net.value.id}&city.id=${city.id}`,
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  )
  const responseOffices = await dataOffices.json()

  cities.value.push({
    id: city.id,
    name: city.nameCase,
    offices: responseOffices.length,
    year: Math.min(...responseOffices.map(item => item.foundationYear)),
    workers: responseWorkers.length,
    link: `${router.currentRoute.value.fullPath}/${city.nameEng}`
  })
}

authorize()
getCities()
</script>

<style scoped>
.news {
  background: #1d232a;
  display: flex;
  align-items: flex-start;
  padding: 24px 50px 0 50px;
}
.news__content {
  position: relative;
  margin-right: 30px;
  flex: 1;
}
.news__loader {
  display: flex;
  align-items: center;
  justify-content: center;
}
.news__side {
  width: 329px;
  position: sticky;
  top: 24px;
  height: fit-content;
}

.block {
  background: #343c42;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 30px;
}
.block--special {
  background: #2a3137;
  border-color: #ffe6a9;
}
.block:last-of-type {
  margin-bottom: 50px;
}
.block__header {
  display: flex;
  align-items: center;
  padding: 16px;
  letter-spacing: 0.02em;
  border-bottom: 1px solid #5d6368;
}

@media only screen and (max-width: 600px) {
  .news {
    background: unset;
    display: unset;
    align-items: unset;
    padding: 0;
  }
  .news__content {
    margin-right: unset;
    flex: unset;
    padding: 16px 16px 88px 16px;
  }
  .news__side {
    display: none;
  }
  .news__loader {
    margin-top: 150px;
  }

  .block {
    margin-bottom: 16px;
  }
  .block:last-of-type {
    margin-bottom: 0;
  }
}
</style>
